import { useSelector } from "react-redux";

const CATEGORY_360_T = "360T_FX_DATA";

export const useModulePricing = () => {
    const useGetModulePricingProducts = (): string[] => {
        const productsInfo = useSelector(state => state.products);

        return productsInfo?.products?.filter(p => p.category === CATEGORY_360_T)?.map(p => p.id);
    };

    const useHasProductModulePricing = (productId): boolean => {
        const productsInfo = useSelector(state => state.products);

        const product = productsInfo?.products?.find(p => p.id === productId);
        return product?.category === CATEGORY_360_T;
    };
    return {
        useGetModulePricingProducts,
        useHasProductModulePricing
    };
};
